/* @ngInject */
function guestResendPasswordService (Utils, CONSTANTS, ConnectorWebService) {
  const service = {
    requestNewPassword
  }
  return service

  function requestNewPassword (email) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_GUESTS_REQUEST_NEW_PASSWORD)
    return ConnectorWebService.post(url, { email })
  }
}

export { guestResendPasswordService }
